/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import {
  ControlProps,
  RankedTester,
  rankWith,
  isStringControl,
  and,
  schemaMatches
} from '@jsonforms/core'

import { withJsonFormsControlProps } from '@jsonforms/react'
import { withHandleChangeEmitter } from '../WithCustomHandlerHOC'

export const SSN: React.FC<ControlProps> = (props: ControlProps) => {
  const {
    label,
    handleChange,
    data,
    path,
    id,
    errors,
    schema,
    required,
    visible,
    uischema,
    enabled
  } = props

  const [showError, setShowError] = useState<boolean>(false)
  const [ssn, setSsn] = useState<string>(data)
  const [ssnUndo, setSsnUndo] = useState<string>(data)

  const getClass = () => {
    return errors && errors.length ? 'form-control is-invalid' : 'form-control'
  }

  const validate = () => {
    required && !data ? setShowError(true) : setShowError(false)
  }

  /**
   * SSN Mask related methods start
   */

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((schema as any).isSsn) {
      _asterisk()
    }
  }, [])

  const _onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let string = event.target.value
    string = string.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    setSsn(string)
    setSsnUndo(string)
    handleChange(path, string)
  }

  const _asterisk = () => {
    if (!ssn) {
      return
    }
    const reg = /.{1,5}/
    const string = ssn
    const uo = string.replace(reg, (m) => '*'.repeat(m.length))

    setSsn(uo)
    validate()
  }

  const _unasterisk = () => {
    setSsn(ssnUndo)
  }

  /**
   * SSN Mask related methods end
   */

  return (
    <>
      {visible && (
        <div className='form-group'>
          <label htmlFor={id} className='custom-input-label'>
            {label}
          </label>
          <input
            type='text'
            value={ssn ?? ''}
            maxLength={9}
            className={getClass()}
            id={id}
            onChange={_onInputChange}
            onBlur={_asterisk}
            onFocus={_unasterisk}
            disabled={!enabled}
            data-testid='ssn-input'
          />

          {(!!errors || showError) && errors.includes('required') && (
            <div className='text-danger'>
              <span>{`${schema.title} is required`}</span>
            </div>
          )}
          {(!!errors || showError) && errors.includes('shorter') && (
            <div className='text-danger'>
              <span>{(uischema as any).minLengthErrorLabel}</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export const ssnControlTester: RankedTester = rankWith(
  4,
  and(
    isStringControl,
    schemaMatches(
      // eslint-disable-next-line
      (schema: { hasOwnProperty: (arg0: string) => any }) =>
        // eslint-disable-next-line no-prototype-builtins
        schema.hasOwnProperty('isSsn')
    )
  )
)

export const SSNControl = withJsonFormsControlProps(
  withHandleChangeEmitter(SSN)
)
